import { SxProps } from "@mui/material";
import { theme } from "theme";

export const CardGrid: SxProps = {
	[theme.breakpoints.up("xl")]: {
		maxHeight: "16em",
	},
};
